// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/utils/loadLanguage.js

// Default export of icons keyed by language code
const languageIcons = {
  en: 'https://afaa.website/s/990b08.png',
  fr: 'https://afaa.website/s/7047dc.png',
  th: 'https://afaa.website/s/179124.webp',
  zh: 'https://afaa.website/s/632764.webp',
  de: 'https://afaa.website/s/0991b2.png'
};

export let languageOptions = []; 
// จะกำหนดค่าเป็น [] ไปก่อน เดี๋ยว initLanguageOptions() จะเป็นคนเซ็ต

// ฟังก์ชันที่จะถูกเรียก 1 ครั้ง เมื่อ App เริ่มต้น หรือจะเรียกเมื่อไรก็ได้
export async function initLanguageOptions() {
  const codes = ['en', 'fr', 'th', 'zh', 'de'];

  const tempOptions = [];
  for (const code of codes) {
    try {
      // ดึงไฟล์ JSON ของแต่ละ code
      const data = await import(`../data/lang/${code}.json`);
      const json = data.default || {};

      // ดึง langName จากใน JSON
      const label = json.langName || code; 
      // หรือตรงนี้จะใช้ fallback เป็น code ถ้าไม่มี langName

      tempOptions.push({
        label,      // ชื่อเต็มของภาษา
        value: code, 
        icon: languageIcons[code] || '' // ใส่ icon ถ้ามี
      });
    } catch (error) {
      console.error('Failed to load language for code:', code, error);
    }
  }
  languageOptions = tempOptions;
}

// ----------------------------------------------------------------
// คลาส LanguageManager ตัวเดิม
// ----------------------------------------------------------------
class LanguageManager {
  constructor() {
    this.translations = {};
  }

  /**
   * โหลดไฟล์ JSON ตามภาษาที่กำหนด
   * @param {string} lang - โค้ดภาษาที่ต้องการ (เช่น 'th', 'en')
   */
  async loadLanguage(lang) {
    try {
      const data = await import(`../data/lang/${lang}.json`);
      this.translations = data.default || {};
    } catch (error) {
      console.error(`Failed to load language data for ${lang}:`, error);
      this.translations = {};
    }
  }

  /**
   * ดึงข้อความสำหรับเมนู
   * @param {string} key - ชื่อ key ใน JSON (เช่น 'dashboard', 'product')
   * @param {string} fallback - ข้อความ fallback ถ้าไม่พบ key
   */
  getMenuLabel(key, fallback = '') {
    return this.translations?.menu?.[key] || fallback;
  }

  /**
   * ดึงข้อความ placeholder ของช่อง search
   */
  getSearchPlaceholder() {
    return this.translations?.placeholders?.search || 'Type in to search...';
  }
}

// export instance เดียว (singleton) ไว้ใช้ทั่วโปรเจค
export const languageManager = new LanguageManager();
